export enum IconPacks {
  Webevolutions
} 
